function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1204",
  "data-name": "Group 1204",
  transform: "translate(-0.405)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_286",
  "data-name": "Rectangle 286",
  transform: "translate(0.405)",
  fill: "#f0f1f2",
  stroke: "#b4b4b4",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 30,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 28,
  height: 29,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_438",
  "data-name": "Path 438",
  d: "M1.9-8A3.517,3.517,0,0,0-1.6-4.5a3.429,3.429,0,0,0,1,2.41A5.487,5.487,0,0,0,2.4,8a9.909,9.909,0,0,0,5-1.34l-1-1.73A8.043,8.043,0,0,1,2.4,6,3.5,3.5,0,0,1,1.49-.88L6.7-2.28,6.18-4.21,1.73-3A1.513,1.513,0,0,1,.4-4.5,1.485,1.485,0,0,1,1.9-6a1.59,1.59,0,0,1,.75.2l1-1.73A3.479,3.479,0,0,0,1.9-8Z",
  transform: "translate(12.505 15)",
  fill: "#818e94"
}));

var SvgArabic = function SvgArabic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArabic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Arabic.c010bc56.svg";
export { ForwardRef as ReactComponent };